import TeamDetailBadge from '@/screens/TeamDetailBadge';

export default function PrivateTabsChatTeamTeamIdBadgeRoute() {
  return <TeamDetailBadge badgePathname="/chat/badge/[badgeId]" />;
}
